// import PropTypes from 'prop-types';
import Image from '../Image';
import styles from './ProductLogoImage.module.scss';

const ProductLogoImage = ({ productLogo, link }) => {
    return (
        <div className={styles['ProductLogoImage']}>
            {link && (
                <a
                    href={link?.href}
                    className={styles['ProductLogoImage__Link']}>
                    <span className="sr-only">{link.text}</span>
                </a>
            )}
            {productLogo && (
                <div className={styles['ProductLogoImage__Wrapper']}>
                    <Image {...productLogo} layout="fill" objectFit="contain" priority={true}/>
                </div>
            )}
        </div>
    );
};

ProductLogoImage.propTypes = {};

export default ProductLogoImage;
